<template>
    <div class="layer">
        <div class="wrap">
            <div id="header">
                <div class="header_wrap">
                    <button type="button" class="menu_btn" @click="$router.push('/login')">
                        <img src="@/assets/common/hd_prev_btn.png" alt="" />
                    </button>
                    <span class="logo">META HEALTH</span>
                </div>
            </div>
            <div class="content">
                <p class="page_title">비밀번호 찾기</p>
                <form id="user_form">
                    <div class="input_wrap">
                        <div class="input_box" id="email_box" v-if="state.changeBox">
                            <span class="ico"><img src="@/assets/user/form_ico1.png" alt="" /></span>
                            <div class="email_box">
                                <input type="text" v-model="state.email" placeholder="이메일" />
                                <span>@</span>
                                <input type="text" name="" :style="!state.showDomain ? 'display:block' : 'display:none'"
                                    v-model="state.domain" placeholder="직접입력" class="direct_email" />
                                <button type="button" :style="!state.showDomain ? 'display:block' : 'display:none'"
                                    class="email_change_btn" @click="emailChangeBtn"></button>
                                <select name="" v-if="state.showDomain" v-model="state.domain" id="email_select"
                                    @change="selecetDomail">
                                    <option value="naver.com">naver.com</option>
                                    <option value="gmail.com">gmail.com</option>
                                    <option value="hanmail.net">hanmail.net</option>
                                    <option value="kakao.com">kakao.com</option>
                                    <option value="직접입력">직접입력</option>
                                </select>
                            </div>
                        </div>
                        <div class="cert_box" :style="!state.changeBox ? 'display:block' : 'display:none'">
                            <div class="input_box">
                                <span class="tit">인증코드 입력</span>
                                <div class="cert_num_box">
                                    <input type="text" v-model="state.applyCode" />
                                    <AuthTimer :timer="state.timer" @end="timeOut"></AuthTimer>
                                </div>
                            </div>
                            <div class="cert_btns">
                                <button type="button" class="re_send_btn" @click="requestApplyCode">재전송</button>
                                <button type="button" class="cert_ok_btn" @click="checkCode">인증</button>
                            </div>
                        </div>
                    </div>
                    <div class="mini_submit_btn" v-if="state.changeBox">
                        <button type="button" id="submit_btn" @click="requestApplyCode">인증요청</button>
                    </div>
                </form>
                <ModalComponent :show="state.isModalOpen" :yes="modal.confirm" :no="modal.cancel"
                    :content="modal.content" @close="modalClose">
                </ModalComponent>
            </div>
        </div>
    </div>
</template>

<script lang="ts" config>
import { reactive, router, res, apiService, AuthTimer, ModalComponent } from "@/BaseComponent";

export default {
    props: {},
    components: {
        AuthTimer,
        ModalComponent,
    },
    setup() {
        const state = reactive({
            email: "" as string,
            domain: "naver.com" as string,
            applyCode: "" as string,
            applyIdx: 0 as number,
            timer: 0 as number,
            showDomain: true as boolean,
            changeBox: true as boolean,
            isModalOpen: false as boolean,
        });


        const modal = reactive({
            content: "" as string,
            confirm: "" as string,
            cancel: "" as string,
            actionCode: 0 as number
        });

        const requestApplyCode = async () => {
            if (state.email != "" && state.email != null) {
                let res: res = await apiService.base.existId(`${state.email}@${state.domain}`);
                if (res.returnCode === 14) {
                    await apiService.base
                        .requestApplyCode(`${state.email}@${state.domain}`)
                        .then(() => {
                            changeBox();
                            state.timer = 180;
                            modal.content = "인증번호가 전송되었습니다.";
                            modal.cancel = "확인";
                            state.isModalOpen = true;
                        })
                        .catch((err) => {
                            console.error(err);
                        });
                } else {
                    modal.content = "없는 사용자입니다.";
                    modal.cancel = "확인";
                    state.isModalOpen = true;
                }
            } else {
                modal.content = "이메일을 전부 입력해주세요";
                modal.cancel = "확인";
                state.isModalOpen = true;
            }
        };

        const checkCode = async () => {
            const res = await apiService.base.checkApplyCode(`${state.email}@${state.domain}`, state.applyCode);
            state.applyIdx = res.idx;
            if (res.returnCode === 0) {
                modal.content = "인증되었습니다.";
                modal.confirm = "확인";
                modal.cancel = "";
                modal.actionCode = 1;
                state.isModalOpen = true;
            } else if (res.returnCode === 33) {
                modal.content = res.description;
                modal.cancel = "확인";
                state.isModalOpen = true;
            }
        };

        const selecetDomail = () => {
            if (state.domain === "직접입력") {
                state.showDomain = !state.showDomain;
                state.domain = "";
            }
        };
        const emailChangeBtn = () => {
            state.showDomain = !state.showDomain;
            state.domain = "naver.com";
        };
        const changeBox = () => {
            state.changeBox = !state.changeBox;
        };

        const modalClose = (result: boolean) => {
            state.isModalOpen = false;
            if (result) {
                switch (modal.actionCode) {
                    case 1:
                        router.replace({ path: "/changePassword", query: { code: state.applyCode, idx: state.applyIdx } });
                        break;

                    default:
                        break;
                }
            }
        };
        const timeOut = () => {
            state.isModalOpen = true;
            modal.content = "인증시간이 초과되었습니다.";
            modal.cancel = '확인';
        };

        return {
            state,
            modal,
            router,
            requestApplyCode,
            checkCode,
            selecetDomail,
            emailChangeBtn,
            changeBox,
            modalClose,
            timeOut,
        };
    },
};
</script>
